(function() {
  // Configuration
  const config = {
    lazyLoadSelector: 'img:not([loading="eager"]), iframe:not([loading="eager"])',
    videoSelector: 'video[data-src]',
    deferredScriptSelector: 'script[data-defer]',
    deferredStyleSelector: 'link[data-defer]'
  };

  // Lazy load images and iframes
  function setupLazyLoading() {
    const lazyElements = document.querySelectorAll(config.lazyLoadSelector);
    lazyElements.forEach(element => {
      if ('loading' in HTMLImageElement.prototype) {
        element.loading = 'lazy';
      } else {
        observeElement(element, () => loadElement(element));
      }
    });
  }

  // Lazy load videos
  function setupVideoLazyLoading() {
    const videos = document.querySelectorAll(config.videoSelector);
    videos.forEach(video => {
      video.preload = 'none';
      observeElement(video, () => loadVideo(video));
     // console.log("setupVideoLazyLoading: ", video.src)
      
    });
  }

  // Defer non-critical scripts
  function deferScripts() {
    const scripts = document.querySelectorAll(config.deferredScriptSelector);
    scripts.forEach(script => {
      script.setAttribute('defer', '');
      script.removeAttribute('data-defer');
    });
  }

  // Defer non-critical styles
  function deferStyles() {
    const styles = document.querySelectorAll(config.deferredStyleSelector);
    styles.forEach(style => {
      style.setAttribute('media', 'print');
      style.setAttribute('onload', "this.media='all'");
      style.removeAttribute('data-defer');
    });
  }

  // Intersection Observer setup
  function observeElement(element, callback) {
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          callback();
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '50px' });
    observer.observe(element);
  }

  // Load element (image or iframe)
  function loadElement(element) {
    if (element.dataset.src) {
      element.src = element.dataset.src;
      element.removeAttribute('data-src');
    }
  }

  // Load video
  function loadVideo(video) {
    if (video.dataset.src) {
      video.src = video.dataset.src;
      video.load();
      video.removeAttribute('data-src');
   //   console.log("Loaded video: ", video.src)
    }
  }

  // Initialize optimizations
  function init() {
    console.log("Start performance optimization.");
    setupLazyLoading();
    setupVideoLazyLoading();
    deferScripts();
    deferStyles();
    console.log("Finished performance optimization.");
  }

  // Run optimizations when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();